import React, { useState, useEffect, Fragment } from "react";
import {
  Typography,
  TextField,
  Box,
  CircularProgress,
  Divider,
  Skeleton,
} from "@mui/material";
import PlantList from "../../components/PlantList/List";
import Showcase from "../../components/PlantList/Showcase";
import PruningTable from "../../components/PlantList/PruningTable";
import AppBarMyGarden from "../../components/AppBar/MyGarden";
import WeedingTable from "../../components/PlantList/WeedingTable";
import QuizComponent from "../../components/Quiz";
import GardenSetup from "../../components/GardenSetup/Root";
import GardenSetupSummary from "../../components/GardenSetup/Summary";
import { useNavigateToTop } from "../../libs/useNavigateToTop";
import ThisMonthsTasks from "../../components/ThisMonthsTasks";
import { calendar } from "../../libs/calendar/calendar";
import { pallete } from "../../libs/pallete";
import { getAuth } from "firebase/auth";

const ScreenMyGarden = ({ data = {} }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermMaintinance, setSearchTermMaintinance] = useState("");
  const [searchTermWeeds, setSearchTermWeeds] = useState("");
  const [isLoading, setIsLoading] = useState(true); // Add isLoading state

  const currentUser = getAuth().currentUser;
  console.log(currentUser);

  const isMyGarden = window.location.pathname.includes("myGarden");

  useEffect(() => {
    // Simulate data loading
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  const navigate = useNavigateToTop();
  const {
    colours,
    plants = [],
    weeds = [],
    soilTexture,
    soilStructure,
    images = [],
    waterFlowRate,
    polygons,
    slope,
    problems = [],

    shareLink,
    preferredServiceSchedule,
    bookServices,
    clientName,
    gardenStyle,
  } = data;
  const name = clientName;

  const prefix = isMyGarden ? "My" : name + "'s";

  const steps = [
    // {
    //   isDone: gardenStyle,
    // },
    {
      isDone: colours,
    },
    {
      isDone: plants && plants.length > 0,
    },
    {
      isDone: weeds && weeds.length > 0,
    },
    {
      isDone: images && images.length > 0,
    },
    {
      isDone: soilTexture,
    },
    {
      isDone: soilStructure,
    },
    {
      isDone: waterFlowRate,
    },
    {
      isDone: polygons,
    },
    {
      isDone: preferredServiceSchedule,
    },
    {
      isDone: shareLink,
    },
    {
      isDone: slope,
    },
    {
      isDone: problems && problems.length > 0,
    },
    {
      isDone: bookServices,
    },
  ];

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSearchChangeMaintinance = (event) => {
    setSearchTermMaintinance(event.target.value);
  };

  const handleShceduleClicked = () => {
    console.log("schedule clicked");
  };

  const handleSearchChangeWeeds = (event) => {
    setSearchTermWeeds(event.target.value);
  };

  const handleSetupClick = () => {
    navigate(`/site/${data.storageDocumentId}/setup`);
  };

  return (
    <Box>
      <AppBarMyGarden
        isMyGarden={isMyGarden}
        siteUuid={data.storageDocumentId}
        clientName={data.clientName}
        clientUuid={data.clientId}
      />
      <Box
        style={{
          padding: "1rem",
          textAlign: "center",
          textAlign: "-webkit-center",
        }}
      >
        {isLoading ? ( // Render spinner if isLoading is true
          <CircularProgress />
        ) : (
          <>
            {name ? (
              <Showcase
                images={images}
                title={`Garden of ${name}`}
                subtitle={`The garden at different points in time`}
              />
            ) : (
              <>
                <Skeleton variant="rectangular" width="100%" height="10rem" />
              </>
            )}

            {(isMyGarden || currentUser) && (
              <GardenSetupSummary
                steps={steps}
                onSetupClick={handleSetupClick}
              />
            )}
            <Divider
              style={{
                marginTop: "3rem",
                background: pallete.warm.main,
              }}
            />
            {/* <ThisMonthsTasks tasks={calendar} /> */}
            {plants.length != 0 && (
              <Fragment>
                <Typography variant="h4" component="h1" mt={6}>
                  {prefix} Plants
                </Typography>
                <Typography variant="subtitle1" component="h2" gutterBottom>
                  Here are all the plants
                </Typography>
                <TextField
                  label="Search"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  variant="outlined"
                  style={{
                    width: "100%",
                    marginBottom: "2rem",
                    borderRadius: "2rem",
                    maxWidth: "40rem",
                  }}
                />
                <PlantList plants={plants} searchTerm={searchTerm} />
                <Divider
                  style={{
                    marginTop: "3rem",
                    background: pallete.warm.main,
                  }}
                />
              </Fragment>
            )}
            {weeds && weeds.length != 0 && (
              <Box
                style={{
                  marginTop: "3rem",
                }}
              >
                <Typography variant="h4" component="h1">
                  {prefix} Weeds
                </Typography>
                <Typography variant="subtitle1" component="h2" gutterBottom>
                  Here are all the weeds we have spotted to keep an eye on
                </Typography>
                <TextField
                  label="Search"
                  value={searchTermWeeds}
                  onChange={handleSearchChangeWeeds}
                  variant="outlined"
                  style={{
                    width: "100%",
                    marginBottom: "2rem",
                    borderRadius: "2rem",
                    maxWidth: "40rem",
                  }}
                />
                <PlantList plants={weeds} searchTerm={searchTermWeeds} />
                <Divider
                  style={{
                    marginTop: "3rem",
                    background: pallete.warm.main,
                  }}
                />
              </Box>
            )}

            {weeds && weeds.length != 0 && (
              <Box
                style={{
                  marginTop: "3rem",
                }}
              >
                <Typography variant="h4" component="h1">
                  Weeding Lookout!
                </Typography>
                <Typography variant="subtitle1" component="h2" gutterBottom>
                  Here are weeds to get ontop of in the season
                </Typography>

                <WeedingTable data={weeds} />
                <Divider
                  style={{
                    marginTop: "3rem",
                    background: pallete.warm.main,
                  }}
                />
              </Box>
            )}

            {plants && plants.length != 0 && (
              <Box
                style={{
                  marginTop: "3rem",
                }}
              >
                <Typography variant="h4" component="h1">
                  Maintenance
                </Typography>
                <Typography variant="subtitle1" component="h2" gutterBottom>
                  Here are scheduled maintenance tasks
                </Typography>
                <TextField
                  label="Search"
                  value={searchTermMaintinance}
                  onChange={handleSearchChangeMaintinance}
                  variant="outlined"
                  style={{
                    width: "100%",
                    marginBottom: "2rem",
                    borderRadius: "2rem",
                    maxWidth: "40rem",
                  }}
                />
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <PruningTable
                    data={plants}
                    searchTerm={searchTermMaintinance}
                  />
                </Box>
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default ScreenMyGarden;
